import { IWebhook } from '@/store/types';
import Axios from 'axios';

const RESOURCE = '/api/webhooks';

export default {
  /**
   * @param {String} webhookId the doc's mongo id
   */
  get(webhookId: string): IWebhook {
    // @ts-ignore
    return Axios.get(`${RESOURCE}/${webhookId}`);
  },

  /**
   * Get all org webhooks
   */
  getAll(): IWebhook[] {
    // @ts-ignore
    return Axios.get(`${RESOURCE}/`);
  },

  /**
   * @param {Object} webhook
   */
  create(webhook: any): IWebhook {
    // @ts-ignore
    return Axios.post(`${RESOURCE}`, webhook);
  },

  /**
   * @param {String} webhookId the doc's mongo id
   */
  verify(webhookId: string): IWebhook {
    // @ts-ignore
    return Axios.post(`${RESOURCE}/${webhookId}/verify`);
  },

  /**
   * @param {String} webhookId the doc's mongo id
   * @param {Object} data the fields to update
   */
  update(webhookId: string, data: any): IWebhook {
    // @ts-ignore
    return Axios.put(`${RESOURCE}/${webhookId}`, data);
  },

  /**
   * @param {String} webhookId the doc's mongo id
   */
  delete(webhookId: string): IWebhook {
    // @ts-ignore
    return Axios.delete(`${RESOURCE}/${webhookId}`);
  },
};
